<template>
  <v-app>
    <!-- WRAPPER QUE RESPETA SAFE AREAS -->
    <div id="app-wrapper">
      
      <!-- WRAPPER QUE LIMITA DIMENSIONES -->
      <div id="app-inner">
        <v-main>
          <router-view />
        </v-main>
      </div>

    </div>
  </v-app>
</template>

<script setup>
import { provide, watch } from 'vue';
import { useRoute } from 'vue-router';
import { createCartStore } from './stores/cart';

const cartStore = createCartStore();
provide('cartStore', cartStore);

const route = useRoute();

watch(
  () => route.meta.title,
  (newTitle) => document.title = newTitle || 'MVExpress',
  { immediate: true }
);
</script>

<style>
/* ============================= */
/*  SAFE AREAS DEL TELÉFONO      */
/* ============================= */

#app-wrapper {
  padding-bottom: env(safe-area-inset-bottom, 25px);
  padding-left: env(safe-area-inset-left, 0);
  padding-right: env(safe-area-inset-right, 0);
  box-sizing: border-box;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

/* En algunos Samsung (A15) la safe-area no se reporta, así que forzamos un mínimo */
@supports (padding-bottom: env(safe-area-inset-bottom)) {
  .fixed-bottom-nav {
    padding-bottom: max(env(safe-area-inset-bottom), 25px);
  }
}

</style>
